<div matRipple class="card bg-primary-light text-center hover:bg-primary trans-ease-out cursor-pointer text-dark border-2 min-w-0">
  <div class="flex p-1 border-b">
    <h3 class="truncate text-center w-full"> <ng-content select="[header]"></ng-content></h3>
  </div>
  <div class="text-left p-1">
    <ng-content select="[content]"></ng-content>
  </div>
  <footer><ng-content select="[footer]"></ng-content></footer>
</div>
